import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Organizations outside the institution that interact with research activities, such as partner systems and institutions.',
    name: 'External Institutions',
    partialId: PartialId.Standard.create('ext_institutions'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
